export function classifyDrop(drag, drop) {
  if (!drag || !drop) return { type: 'ignore' };
  if (drag.rowKind === 'router') return { type: 'ignore' };
  if (drop.dropKind === 'strip') {
    if (drag.rowKind !== 'member' || drag.parentRouterId == null) return { type: 'ignore' };
    return { type: 'remove', routerId: drag.parentRouterId, assistantId: drag.assistantId };
  }
  if (drop.dropKind === 'member') return { type: 'ignore' };
  if (drop.assistantId == null || drop.assistantId === drag.assistantId) return { type: 'ignore' };
  if (drop.dropKind === 'router') {
    return { type: 'add', targetId: drop.assistantId, assistantId: drag.assistantId };
  }
  if (drop.dropKind === 'assistant') {
    return { type: 'make-router', targetId: drop.assistantId, assistantId: drag.assistantId };
  }
  return { type: 'ignore' };
}

export function dialogStateForDrop(classification, assistantsById) {
  if (!classification || classification.type === 'ignore' || classification.type === 'remove') return null;
  const target = assistantsById.get(classification.targetId);
  const specialist = assistantsById.get(classification.assistantId);
  if (!target || !specialist) return null;
  const already = (target.team_members || []).some((member) => member.assistant_id === specialist.id);
  const others = (specialist.member_of || []).filter(
    (item) => item.router_id !== target.id && item.router_name
  );
  return {
    mode: already ? 'already' : classification.type,
    specialistName: specialist.name,
    targetName: target.name,
    targetId: target.id,
    specialistId: specialist.id,
    others: already ? [] : others,
  };
}

export function noteIsValid(value) {
  const trimmed = (value || '').trim();
  return trimmed.length > 0 && trimmed.length <= 500;
}

export function operationsForDialog({ targetId, specialistId, hint, move, otherRouterIds }) {
  const operations = [{
    kind: 'add',
    targetId,
    specialistId,
    hint: (hint || '').trim(),
  }];
  if (move) {
    (otherRouterIds || []).forEach((routerId) => {
      if (routerId !== targetId) {
        operations.push({ kind: 'remove', routerId, specialistId });
      }
    });
  }
  return operations;
}

export function operationsForRemove({ routerId, specialistId }) {
  return [{ kind: 'remove', routerId, specialistId }];
}

function membersFromFresh(fresh) {
  return (fresh.members || []).map((member) => ({
    assistant_id: member.assistant_id,
    routing_hint: member.routing_hint || '',
    enabled: member.enabled !== false,
  }));
}

function withPositions(members) {
  return members.map((member, index) => ({ ...member, position: index }));
}

export function addBodyFromFresh(fresh, specialistId, hint) {
  const members = membersFromFresh(fresh);
  if (members.some((member) => member.assistant_id === specialistId)) {
    return { already: true };
  }
  return {
    already: false,
    body: {
      router_mode: true,
      router_contextualize: fresh.router_mode ? fresh.router_contextualize !== false : true,
      members: withPositions([
        ...members,
        { assistant_id: specialistId, routing_hint: hint.trim(), enabled: true },
      ]),
    },
  };
}

export function removeBodyFromFresh(fresh, specialistId) {
  return {
    router_mode: true,
    router_contextualize: fresh.router_contextualize !== false,
    members: withPositions(
      membersFromFresh(fresh).filter((member) => member.assistant_id !== specialistId)
    ),
  };
}

export async function runMembershipPuts({ operations, getTeam, saveTeam }) {
  for (let index = 0; index < operations.length; index += 1) {
    const operation = operations[index];
    const routerId = operation.kind === 'add' ? operation.targetId : operation.routerId;
    try {
      const fresh = await getTeam(routerId);
      if (operation.kind === 'add') {
        const built = addBodyFromFresh(fresh, operation.specialistId, operation.hint);
        if (built.already) return { status: 'already', failedIndex: index, routerId };
        await saveTeam(routerId, built.body);
      } else {
        await saveTeam(routerId, removeBodyFromFresh(fresh, operation.specialistId));
      }
    } catch (error) {
      return {
        status: 'error',
        failedIndex: index,
        routerId,
        message: error?.message || 'Failed to save team',
      };
    }
  }
  return { status: 'saved', failedIndex: -1, routerId: null, message: '' };
}
